import { useQuery } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import axios from "axios";

const fetchMyOrders = async (token) => {
  const response = await axios.get(
    `${process.env.REACT_APP_SERVER_URL}/order/orders/me`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data.orders;
};

const useMyOrders = () => {
  const { token, isLoggedIn } = useContext(AuthContext);

  return useQuery("myOrders", () => fetchMyOrders(token), {
    enabled: !!token && isLoggedIn,
  });
};

export default useMyOrders;
